import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { TokenService } from '../services/auth/token.service';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {

    constructor(private router: Router, private tokenService: TokenService, private authService: AuthService){
        
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes('api/global-catalogs/') 
            || req.url.includes('tutum-sanet.s3')) {
            //Se excluye este servicio de autenticación
            req = this.addContentTypeJson(req);
        } else {
            const token = this.tokenService.getToken();

            if (this.tokenService.isTokenExpired() && token !== "") {
                //Token ha expirado, y se hace el refresh
                return this.renewingToken(req, next);
            } else if(token) {
                //Token activo, se agrega en el encabezado para las peticiones
                req = this.addToken(req, token);
            }
            //Se agrega el tipo de contenido que será JSON
            req = this.addContentTypeJson(req);
        }
        return next.handle(req).pipe(
            catchError((error) => {
                // Checa si el token a expirado para renovar el token
                if (error.status === 401) {
                    return this.renewingToken(req, next);
                }        
                return throwError(error);
            })
        );        
    }

    private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    private addContentTypeJson(request: HttpRequest<any>): HttpRequest<any> {
        return request.clone({
            setHeaders: {
                'Content-Type': 'application/json'
            }
        });
    }

    private renewingToken(request: HttpRequest<any>, next: HttpHandler){
        //Limpia el token caducado
        this.tokenService.saveToken("");
        // Conectando al servicio para actualizar el token
        return this.authService.refreshToken(this.tokenService.getRefreshToken()).pipe(            
            switchMap(newToken => {
                this.tokenService.saveToken(newToken);
                request = this.addContentTypeJson(request);
                request = this.addToken(request, newToken);
                return next.handle(request);
            }),
            catchError((error) => {
                //imprime el error
                console.log('Error handling expired access token:', error);
                return throwError(error);
            })
        );
    }
}
